import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'
import { Link, Image, RichText } from '@sitecore-jss/sitecore-jss-react';

import IconSVG from "../../utilities/FrontFunctions/IconSVG"

import '../../assets/css/0020_objects/0780_obj_contact_question_formation.css'
import '../../assets/css/0020_objects/0710_obj_carousel_formation.css';

class ObjPushContactezNousQuestionFormation extends Component {
	render() {
        const { datasPage } = this.props;

        return (<>{datasPage && <>
			<div className="obj_contact_question_formation">
				<div className="ctn_text">
					<h3 className="t_title">{datasPage["Contact Name"]?.value}</h3>
					<p className="t_desc"><RichText field={datasPage["Contact Text"]}/> <strong>{datasPage["Contact Phone"]?.value}</strong></p>
					<div className="ctn_cta">
						<Link className="obj_cta var_picto var_email reverse" field={datasPage["Contact Url"]?.value}>
							<IconSVG icon="email_open" width="21" height="17" />
							{datasPage["Contact Url"]?.value.text}
						</Link>
					</div>
					<p className="t_mentions">{datasPage["Contact Mentions"]?.value.text}</p>
				</div>
				<div className="obj_image">
                    <Link field={datasPage["Contact Url"]?.value}>
                        <picture className="ctn_image fade-in">
                            <Image media={datasPage["Contact Image"]?.value}/>
					    </picture>
                    </Link>
				</div>

			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjPushContactezNousQuestionFormation));